import { SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

import { ONE_PAGE_STYLE_OPTIONS } from '../types';

export const allOnePageStyles = Object.values(ONE_PAGE_STYLE_OPTIONS);

export const onePageStylesAccessRules = {
  [SUBSCRIPTION_PLAN.UNAUTHORIZED]: [ONE_PAGE_STYLE_OPTIONS.FIRST_STYLE],
  [SUBSCRIPTION_PLAN.STARTER]: allOnePageStyles,
  [SUBSCRIPTION_PLAN.FREE]: [ONE_PAGE_STYLE_OPTIONS.FIRST_STYLE],
  [SUBSCRIPTION_PLAN.LIGHT]: allOnePageStyles,
  [SUBSCRIPTION_PLAN.STANDARD]: allOnePageStyles,
};
